import { useSeo, renderHeadToString, type SeoOptions } from "@/hooks/useSeo";

/**
 * Declarative SEO. On the client, useSeo() applies the tags to document.head.
 * During prerender (no document), we stash the head HTML on a global so the
 * prerender script can inject it into that route's static HTML file.
 */
export function Seo(props: SeoOptions) {
  useSeo(props);
  if (typeof document === "undefined") {
    (globalThis as { __SSR_HEAD__?: string }).__SSR_HEAD__ = renderHeadToString(props);
  }
  return null;
}
